// extracted by mini-css-extract-plugin
export default {"uploadArea":"UploadArea_uploadArea__kIcQk"};